function resolveStagger(value, index, total, defaultValue) {
    if (typeof value === "function") {
        return value(index, total);
    }
    return value ?? defaultValue;
}

export { resolveStagger };
